<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <span v-on="on" :class="contentClass" :style="{ cursor }">
        <slot :timeago="timeago">{{ timeago }}</slot>
      </span>
    </template>
    <slot></slot>
    <slot name="tooltip">
      <span :class="toolipClass">{{ getDateString(date) }}</span>
    </slot>
  </v-tooltip>
</template>

<script>
import moment from 'moment'
import { getDateString } from '../libs/utils'
export default {
  props: {
    date: { type: Date, required: true },
    contentClass: { type: String, required: false, default: '' },
    toolipClass: { type: String, required: false, default: '' },
    cursor: { type: String, required: false }
  },
  data () {
    return {
      intervalId: null,
      diffTime: 0
    }
  },
  computed: {
    timeago () {
      return moment.utc(this.date).fromNow()
    }
  },
  methods: {
    getDateString (date) {
      return getDateString(date)
    }
  },
  mounted () {
    this.intervalId = setInterval(() => {
      this.diffTime = Date.now() - this.date
    }, 1000)
  },
  beforeDestroy () {
    this.intervalId !== null && clearInterval(this.intervalId)
  }
}
</script>

